// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "chunks/" + chunkId + "." + {"65":"e2ec1759","377":"c762203e","976":"b8ea76cc"}[chunkId] + ".js";
};